'use strict';

function FlightManagementDataRetrieverService(restangular, $q, flightManagementDataRetrieverFilterService, flightManagementParallelizeDataRetrieverService) {
  var restangularFlightDomain = restangular.one('domain').one('flights');
  var restangularServicesDomain = restangular.one('domain').one('services');
  function retrieveData(service, path, filter) {
    var requests = {};
    requests[path] = service.customGET(path, filter);
    return $q.all(requests).then(function (responses) {
      return responses[path];
    });
  }
  function getInventoryManagementData(selectedRows) {
    var filter = flightManagementDataRetrieverFilterService.buildInventoryManagementFilter(selectedRows);
    return retrieveData(restangularFlightDomain, 'mergedlegclasssegclass', filter);
  }
  function getFlightSummaryData(screenState) {
    return flightManagementParallelizeDataRetrieverService.parallelize('domain/flights', 'flattenedFlightSummary', flightManagementDataRetrieverFilterService.buildFlightSummaryFilter, 'resources', screenState);
  }
  function getOverbookingManagementData(selectedFlights) {
    var filter = flightManagementDataRetrieverFilterService.buildOverbookingFilter(selectedFlights);
    return retrieveData(restangularFlightDomain, 'flattenedLegCabins', filter);
  }
  function getServiceManagementData(selectedFlights) {
    var filter = flightManagementDataRetrieverFilterService.buildServiceManagementFilter(selectedFlights);
    return retrieveData(restangularServicesDomain, 'serviceManagementByServiceId', filter);
  }
  return {
    getInventoryManagementData: getInventoryManagementData,
    getFlightSummaryData: getFlightSummaryData,
    getOverbookingManagementData: getOverbookingManagementData,
    getServiceManagementData: getServiceManagementData
  };
}
FlightManagementDataRetrieverService.$inject = ['Restangular', '$q', 'FlightManagementDataRetrieverFilterService', 'FlightManagementParallelizeDataRetrieverService'];
module.exports = FlightManagementDataRetrieverService;